module.exports = __webpack_public_path__ + "img/event_type_flag.57398792.svg";